import { createTypes } from "reduxsauce";

export default createTypes(
    `
    FETCH_CMS_CONTENT_INIT
    FETCH_CMS_CONTENT_SUCCESS
    FETCH_CMS_CONTENT_FAILURE

    CREATE_CHR_SERVICE_ORDER_INIT
    CREATE_CHR_SERVICE_ORDER_SUCCESS
    CREATE_CHR_SERVICE_ORDER_FAILURE

    FETCH_REGO_DETAILS_INIT
    FETCH_REGO_DETAILS_SUCCESS
    FETCH_REGO_DETAILS_FAILURE

    FETCH_CHR_LANDING_DATA_INIT
    FETCH_CHR_LANDING_DATA_SUCCESS
    FETCH_CHR_LANDING_DATA_FAILURE

    UPDATE_CHR_SERVICE_ORDER_INIT
    UPDATE_CHR_SERVICE_ORDER_SUCCESS
    UPDATE_CHR_SERVICE_ORDER_FAILURE

    SEARCH_CHR_SERVICE_ORDER_INIT
    SEARCH_CHR_SERVICE_ORDER_SUCCESS
    SEARCH_CHR_SERVICE_ORDER_FAILURE

    FETCH_CHR_SERVICE_ORDER_INIT
    FETCH_CHR_SERVICE_ORDER_SUCCESS
    FETCH_CHR_SERVICE_ORDER_FAILURE

    CHR_SERVICE_ORDER_PAYMENT_INIT
    CHR_SERVICE_ORDER_PAYMENT_SUCCESS
    CHR_SERVICE_ORDER_PAYMENT_FAILURE

    UPDATE_FORM_STATE
    CHR_PAYMENT_SESSION_INIT
    UPDATE_SHOW_CAR_HISTORY_FLOW_INIT_MODAL

    UPDATE_CHR_FORM_DATA

    FETCH_CHR_SERVICE_ORDER_LIST_INIT
    FETCH_CHR_SERVICE_ORDER_LIST_SUCCESS
    FETCH_CHR_SERVICE_ORDER_LIST_FAILURE

    RESET_CHR_FORM_DETAILS

    UPDATE_PAYMENT_MODE
    UPDATE_AGREE
`,
    {
        prefix: "carHistoryReport/"
    }
);
